import Block from './Block';
import { ServerSideRender } from './components'

/**
 * Class Block
 */
export default class ServerSideBlock extends Block {
    render() {
        return <ServerSideRender context={this.state}/>
    }
}
